'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';

/**
 * Styling injected by the consuming product into the shared internal components
 * (e.g. `ErrorContainer`, `EventSkeleton`) so they stay decoupled from any
 * product-specific styled context.
 */

export const SharedComponentsStyledContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") SharedComponentsStyledContext.displayName = "SharedComponentsStyledContext";
export function useSharedComponentsStyledContext() {
  const value = React.useContext(SharedComponentsStyledContext);
  if (!value) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: useSharedComponentsStyledContext must be used within a SharedComponentsStyledContext.Provider. ' + 'The shared internal components require the product to inject their utility classes. ' + 'Ensure the component is rendered inside an EventCalendar, EventCalendarPremium, or EventTimelinePremium component, ' + 'a standalone view, or another component that provides SharedComponentsStyledContext.' : _formatErrorMessage(286));
  }
  return value;
}